import { PaletteMode, ThemeOptions, createTheme } from '@mui/material/styles';

import { createPalette } from './palette';
import typography from './typography';
import shadows from './shadows';
import mixins from './mixins';
import createComponents from './components';

export function createAppTheme(mode: PaletteMode) {
    const palette = createPalette(mode);
    const themeOptions: ThemeOptions = {
        palette,
        typography,
        shadows,
        mixins,
        components: createComponents(palette),
    };

    return createTheme(themeOptions);
}

const theme = createAppTheme('light');

export default theme;
